// Accept attribute + validation shared by all image upload inputs.
// We explicitly list HEIC/HEIF and other extensions because some browsers
// report an empty MIME type for them, so `image/*` alone won't surface them
// in the file picker or pass a `type.startsWith("image/")` check.

export const ACCEPT_IMAGES =
  "image/*,.heic,.heif,.heics,.heifs,.avif,.bmp,.tif,.tiff";

const IMAGE_EXT_RE = /\.(jpe?g|png|gif|webp|avif|bmp|svg|tiff?|heic|heif|heics|heifs)$/i;

/** True when a selected File looks like an image we accept for upload. */
export function isImageFile(file: File): boolean {
  if (file.type && file.type.startsWith("image/")) return true;
  // Fallback for browsers that report an empty type for HEIC/HEIF etc.
  return IMAGE_EXT_RE.test(file.name);
}
